// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InterceptionDirectionSchema = z.enum(['REQUEST','RESPONSE','BOTH'] as const);

export type InterceptionDirectionType = `${z.infer<typeof InterceptionDirectionSchema>}`

export default InterceptionDirectionSchema;
